import { Input, Form, Button } from "cdhs-ui-library";
import { BsArrowRightShort } from "react-icons/bs";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { SubmitHandler } from "react-hook-form";
import { ContactRequest } from "../../types";
import styles from './profileForm.module.scss';
import { contactInfo } from "../../store/user/userSlice";
import { createProfileFormSchema } from "../../services/profileValidation";
import { ProfileFormData } from "../../services/profileValidation";
import { useState } from "react";
import { BiSolidError } from "react-icons/bi";
import { useTranslations } from "../../contexts/LanguageContext";

interface ProfileFormProps {
    setDisplayContactForm: React.Dispatch<React.SetStateAction<boolean>>
}


function ProfileForm({ setDisplayContactForm }: ProfileFormProps) {
    const [preferredContactMethod, setPreferredContactMethod] = useState<string>('');
    const [preferredContactMethodError, setPreferredContactMethodError] = useState<string | null>(null);
    const t = useTranslations()
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const lang = useAppSelector(state => state.lang.language)
    const profileFormSchema = createProfileFormSchema(t);


    const submitForm: SubmitHandler<ProfileFormData> = async (data) => {

        let isSelectValid = true;
        if (!preferredContactMethod) {
            setPreferredContactMethodError("Preferred contact method is required.");
            isSelectValid = false;
        } else {
            setPreferredContactMethodError(null);
        }

        if (!isSelectValid) {
            return false
        }
        
        const contactPayload: ContactRequest = {
            ClientId: user?.ClientId,
            SessionId: user?.SessionId,
            PreferredName: data.preferredName,
            Email: data.email,
            PhoneNumber: data.phoneNumber,
            Address: data.streetAddress,
            Address2: data.unitAddress,
            City: data.city,
            State: data.state,
            ZipCode: data.zipCode,
            Country: data.country,
            Language: lang,
            PreferredContact: preferredContactMethod
        };

        try {
            console.log("CONTACT PAYLOAD: ", contactPayload)
            const result = await dispatch(contactInfo(contactPayload)).unwrap();
            if (result) {
                setDisplayContactForm(false)
            }
            return true;
        } catch (error) {
            return false;
        }
    };

    const handlePreferredContactMethodChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setPreferredContactMethod(value);
        if (value) {
            setPreferredContactMethodError(null);
        }
    };

    return (
        <div className={styles.formContainer}>
            <Form onSubmit={submitForm} validationSchema={zodResolver(profileFormSchema)}>
                <div className={styles.formContent}>
                    <Input name="preferredName" label="Preferred Name" type="text" />
                    <Input name="email" label="Email" type="email" message="Do you have a new email address?" />
                    <Input name="confirmEmail" label="Confirm Email" type="email" />
                    <Input name="phoneNumber" label="Phone Number" type="text" message="As 999-999-9999" />
                    <Input
                        name="streetAddress"
                        label="Street Address"
                        type="text"
                    />
                    <Input
                        name="unitAddress"
                        label="Apt/Unit"
                        type="text"
                    />
                    <div className={styles.inputGroup}>
                        <div className={styles.longInput} >
                            <Input
                                name="city"
                                label="City"
                                type="text"
                            />
                        </div>
                        <div className={styles.shortInput}>
                            <Input
                                name="state"
                                label="State"
                                type="text"
                            />
                        </div>
                    </div>

                    <div className={styles.inputGroup}>
                        <div className={styles.shortInput}>
                            <Input
                                name="country"
                                label="Country"
                                type="text"
                            />
                        </div>
                        <div className={styles.longInput}>
                            <Input
                                name="zipCode"
                                label="ZipCode"
                                type="text"
                            />
                        </div>
                    </div>
                    <div className={styles.selectContainer}>
                        <label htmlFor="contact_method">Preferred Contact Method:</label>
                        <select
                            id="contact_method"
                            name="preferredContactMethod"
                            value={preferredContactMethod}
                            onChange={handlePreferredContactMethodChange} 
                            className={`${preferredContactMethodError ? styles.selectError : ''}`} 
                            aria-invalid={preferredContactMethodError ? "true" : "false"} 
                            aria-describedby={preferredContactMethodError ? "contact-method-error" : undefined} 
                        >
                            <option value="">Please select...</option>
                            <option value="email">Email</option>
                            <option value="phone">Phone</option>
                            <option value="text">Text</option>
                        </select>
                        {preferredContactMethodError && (
                            <div id="contact-method-error" className={styles.messageContainer}>
                                <BiSolidError className={styles.errorIcon} />
                                <p className={styles.message}>{preferredContactMethodError}</p>
                            </div>
                        )}
                    </div>

                    <div className={styles.buttonGroup}>
                        <Button
                            type="submit"
                            caption="Submit"
                            iconPosition="Right"
                            fullWidth={true}
                            image={<BsArrowRightShort />}
                            variant="NYTD"
                            size="medium"
                        />
                        <Button
                            caption="Cancel"
                            fullWidth={true}
                            variant="NYTD"
                            mode="light"
                            size="medium"
                            onClick={() => setDisplayContactForm(false)}
                        />
                    </div>
                </div>
            </Form></div>
    )
}

export default ProfileForm